(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-wb-faq]';

  function initFaq(section) {
    if (!section || section.__wbFaqInit) return;

    var items = section.querySelectorAll('.wb-faq__item');
    var singleOpen = section.getAttribute('data-single-open') === 'true';

    if (!items.length) return;

    section.__wbFaqInit = true;

    items.forEach(function (item) {
      var summary = item.querySelector('.wb-faq__summary');
      if (!summary) return;

      summary.addEventListener('click', function () {
        if (!singleOpen) return;

        window.requestAnimationFrame(function () {
          if (!item.hasAttribute('open')) return;

          items.forEach(function (otherItem) {
            if (otherItem !== item) {
              otherItem.removeAttribute('open');
            }
          });
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector(SECTION_SELECTOR);
    if (section) initFaq(section);
  });
})();